import { File } from '../file';
import { BenefitsList } from './benefits-list';
import { ContentButton } from './button';

/**
 * Model definition for BenefitsList
 */
export interface BenefitsListImage {
  __component: 'content.benefits-list-image';
  id: string;
  benefitsList?: BenefitsList;
  cta?: ContentButton;
  media?: File;
}

export function isBenefitsListImage(obj: { __component?: string }): obj is BenefitsListImage {
  return obj.__component === 'content.benefits-list-image';
}
